var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVtKg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50px",
    height: "50px",
    viewBox: "0 0 132.873 132.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1383",
    "data-name": "Group 1383",
    transform: "translate(-1689.546 -420.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    d: "M5971.334,489.687a65.019,65.019,0,1,1-65.017-65.026A65.018,65.018,0,0,1,5971.334,489.687Z",
    transform: "translate(-4150.332 -3)",
    fill: "none",
    stroke: "#272427",
    strokeMiterlimit: 10,
    strokeWidth: 2.835
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1382",
    "data-name": "Group 1382",
    transform: "translate(0 -1.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M5916.38,464.573a25.733,25.733,0,0,0-35.362,36.612",
    transform: "translate(-4145.453 11.81)",
    fill: "none",
    stroke: "#272427",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.126
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M5930.6,503.418a25.732,25.732,0,0,0,1.21-29.611",
    transform: "translate(-4154.203 9.576)",
    fill: "none",
    stroke: "#272427",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.126
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M5874.59,509.583h49.789a36.03,36.03,0,1,0-49.789,0Z",
    transform: "translate(-4143.501 13.761)",
    fill: "none",
    stroke: "#272427",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.126
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M5925.991,462.825",
    transform: "translate(-4150.332 -10)",
    fill: "#272427"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 7.363,
    cy: 7.363,
    r: 7.363,
    transform: "translate(1748.621 489.247)",
    fill: "#272427"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_226",
    "data-name": "Line 226",
    y1: 17.665,
    x2: 19.632,
    transform: "translate(1755.983 478.945)",
    fill: "none",
    stroke: "#272427",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M5906.315,521.344",
    transform: "translate(-4150.332 -10)",
    fill: "none",
    stroke: "#272427",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.835
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_282",
    "data-name": "Line 282",
    x2: 88,
    transform: "translate(1711.983 456.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_283",
    "data-name": "Line 283",
    y1: 6,
    transform: "translate(1743.983 456.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_284",
    "data-name": "Line 284",
    y1: 6,
    transform: "translate(1767.983 456.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtKg);
export default __webpack_public_path__ + "static/media/VtKg.d900bea9.svg";
export { ForwardRef as ReactComponent };